<template>
  <splash></splash>
  <div class="container mt-4" dir="rtl">

    <sidebar></sidebar>
    <div style="    position: absolute;
    right: 28vw;
    width: 51vw; height: auto;" class="card-panel-main col-lg-9 mb-5">
      <div v-show="Isblur" class="splash"></div>

      <div class="card card-body card-panel-box border-0" style="    margin: 1vw .9vw;">
        <div class="col-lg-12">
          <div class="card card-body card-panel-box border-0" style="background-color:unset;">
            <div class="row d-flex justify-content-start">
              <div class="d-flex justify-content-between">
                <h2 style="font-size: 1.2vw !important"> ارکان اجرایی    </h2>

                <div class="d-flex changer" >
                  <p style="padding-right: 1vw;">
                    جدول
                  </p>
                  <router-link to="/executive_elements/chart">
                    نمودار
                  </router-link>
                </div>

              </div>

<div class="d-flex align-items-end justify-content-end mb-2">
  <a   style="margin-top: 1.3vw; margin-left: 0.5vw;" class="btn btn-primary bg-danger border-danger btn-submit-1" v-if="seconder_ban || approver_ban" v-show="!status_show" @click="infoCancelledModal=true">   دلایل عدم تایید</a>

</div>
              <center v-if="status_approver">
                <div class="alert alert-success w-25">
                  تایید نهایی!
                </div>
              </center>
              <center v-if="!status_show && all_items.length">

                <div v-if="seconder_ban" class="alert alert-warning w-50" @click="infoCancelledModal=true">
                  <div v-if="type==='producer'">
                    کاربرگ توسط مدیر عامل ؛ تایید نشد!
                  </div>
                  <div v-else>
                    این کاربرگ قبلا توسط شما رد شده است و الان اصلاح شده است!

                  </div>
                </div>
              </center>



              <center v-if="!status_show">
                <div v-if="approver_ban" @click="infoCancelledModal=true" class="alert alert-info" style="width: 30vw;">
                  کاربرگ توسط دبیر کمسیون بهره وری ؛ تایید نشد!
                </div>
              </center>
              <center v-if="status_seconder_step">
                <div v-if="status_seconder" class="alert alert-info w-50">
                  در انتظار تایید توسط مدیر عامل
                </div>
                <div v-if="!status_seconder" class="alert alert-info" style="width: 24vw;">
                  در انتظار تایید توسط دبیر کمسیون بهره وری
                </div>
              </center>
              <div v-if="show_insert && data_entry" class="row">
                <div class="col-lg-4 mb-3">
                  <label class="form-label required">عنوان رکن اجرایی</label>
                  <input v-model="name" class="form-control" type="text" name="" required>
                </div>
                <div class="col-lg-4 mb-3">
                  <label class="form-label ">مافوق  </label>
                  <v-select class="w-100" :options="all_items" dir="rtl" v-model="parent_item" label="name"
                            style="width: 12vw;   border-radius: .5vw">
                    <template v-slot:no-options>موردی یافت نشد</template>
                  </v-select>                </div>
                <div class="col-lg-4 mb-3 d-flex">
                  <button v-if="!is_update" @click.prevent="submitForm" class="btn btn-primary btn-submit-1 mt-4">افزودن</button>
                  <button v-else @click.prevent="update(id_tem)" class="btn btn-primary btn-submit-1 mt-4">ویرایش</button>
                  <Reset style="width: 1.3vw; height: 1.3vw; transform: translateY(1.7vw) translateX(-1vw)" @click.prevent="resetForm" v-if="is_update" />
                </div>
              </div>
              <hr class="mb-2">
              <div class="d-flex justify-content-between mb-2">
                <input v-model="searchUser" type="text" class="form-control" style="width: 20vw;"
                       placeholder="جستجو بر اساس نام ارکان...">

              </div>
            </div>

            <div class="table-responsive mt-3">

              <div style="overflow-y: scroll; height: 50vw;" :style="filteredItems.length < 19 ? 'height: auto;' : ''">

              <table class="table table-striped" v-show="all_items.length">
                <thead>
                <tr>
                  <th style="width: 1vw;">ردیف</th>
                  <th >نام رکن  </th>
                  <th >مافوق    </th>
                  <th style="width: 10vw;"> اعضای کمیته  </th>
                  <th v-if="show_insert && data_entry" style="width: 5vw;">عملیات</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item,index) in filteredItems" :style="setcolor(item['level'])" >
                  <td scope="row">{{ index + 1 }}</td>

                  <td
                      style="text-align: center">{{ item['name'] }}
                  </td>
                  <td

                      style="text-align: center">
                    <span v-if="item.parent">{{item.parent.name }}</span>
                    <span v-else>--</span>
                  </td>
                  <td>
                  <router-link v-if="show_insert && data_entry" :to="`/executive_elements/habits/${item.id}/${item.name}`" class="btn btn-submit-1 btn-primary w-100">تکمیل / بروزرسانی</router-link>
                    <router-link v-else :to="`/executive_elements/habits/${item.id}/${item.name}`" class="btn btn-submit-1 btn-primary w-100">مشاهده</router-link>
                  </td>

                  <td v-if="show_insert && data_entry">
                    <div class="d-flex justify-content-start align-items-start">



                      <a @click.prevent="edit(item['id'], item.name, item.parent)" href="#">
                        <img
                             class="table-edit-img"
                             src="../../../../assets/img/pen.svg"
                             alt="edit"></a>
                      <a class="mx-1" @click.prevent="deleteModalMethod(item['id'])" href="#">
                        <img
                             class="table-delete-img"
                             src="../../../../assets/img/delete.svg"
                             alt="delete"></a>
                    </div>
                  </td>
                </tr>

                </tbody>
              </table>

            </div>
              <div v-if="all_items.length" class="mt-3 d-flex align-items-center justify-content-center position-relative">
                <a  target="_blank" :href="`${this.download_url}/ProductivityCommitteeMembers/${$cookies.get('id_login')}?token=${$cookies.get('id_login')}`" class="btn btn-submit-1 btn-primary">خروجی word</a>
                <a
                    v-if="not_show"
                    :style="type==='producer' ? 'width: 11vw': ''"
                    style="margin-top: 0vw;margin-left: 1vw; margin-right: 0.2vw; background-color: green; border-color: green"
                    class="btn btn-primary btn-submit-1 "


                >
                  <div v-if="!status_loading">

                    <span @click="acceptComplete" v-if="type==='approver'">  تایید </span>
                    <span style="font-size: 0.9vw;" @click="acceptCompleteModal=true" v-else>    ارائه جهت تایید مدیرعامل</span>

                  </div>

                  <div v-else>
                    <div class="loader-line"></div>

                  </div>
                </a>
                <div dir="rtl" class="modal__error slide-top" v-show="acceptCompleteModal"
                     style="z-index: 999999999999999; top: 40%;">
                  <div>
                    <p>اخطار</p>
                    <p @click="acceptCompleteModal=!acceptCompleteModal">❌</p>
                  </div>
                  <div>
                    <p>آیا از ارائه به مدیرعامل مطمئن هستید؟</p>

                    <div class="form-buttons row d-flex justify-content-around mt-5 mb-3" style="width: 20vw;">
                      <button @click="acceptCompleteModal=!acceptCompleteModal" class="btn btn-primary btn-back"
                              type="submit">برگشت
                      </button>
                      <button class="btn btn-primary btn-approve" @click="acceptComplete">تایید</button>
                    </div>
                  </div>
                </div>
                <a v-if="type==='approver' && not_show"
                   style="margin-top: 0vw;margin-left: 1vw; margin-right: 0.2vw;background-color: red; border-color: red;  "
                   class="btn btn-primary btn-submit-1 "
                   @click="acceptComplete2"
                >
                  <div v-if="!status_loading2">
                    <span>عدم تایید</span>
                  </div>

                  <div v-else>
                    <div class="loader-line"></div>

                  </div>
                </a>
              </div>
            </div>
            <center v-show="!all_items.length">
              <span v-if="type==='producer'">ارکان اجرایی  وجود ندارد</span>

              <span v-else>
            در انتظار تکمیل کاربرگ توسط دبیرکمیته بهره وری
          </span>
            </center>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Jobs -->

  <!-- modal  -->
  <div dir="rtl" class="modal__error slide-top" v-show="deleteModal" style="z-index: 999999999999999">
    <div>
      <p>حذف</p>
      <p @click="deleteModal=!deleteModal">❌</p>
    </div>
    <div>
      <p>آیا میخواهید حذف کنید!</p>

      <div class="form-buttons row d-flex justify-content-around mt-5 mb-3" style="width: 20vw;">
        <button @click="deleteModal=!deleteModal" class="btn btn-primary btn-back" type="submit">برگشت</button>
        <button class="btn btn-primary btn-approve" @click="deleteItemForm(id)">تایید</button>
      </div>
    </div>
  </div>
  <!-- modal  -->
  <!-- modal  -->
  <div dir="rtl" class="modal__error slide-top" v-show="Error" style="z-index: 999999999999999">
    <div>
      <p>خطا</p>
      <p @click="Error=!Error">❌</p>
    </div>
    <div>
      <p>{{ ErrorM }}</p>
      <button @click="Error=!Error">تایید</button>
    </div>
  </div>
  <!-- modal  -->
  <!-- modal  -->
  <div dir="rtl" class="modal__error slide-top" v-show="infoModal" style="z-index: 999999999999999">
    <div>
      <p>جزئیات</p>
      <p @click="infoModal=!infoModal">❌</p>
    </div>
    <div>
      <div style="background-color: #fff; border-radius: 1vw; width: 28vw; padding: 1vw;">

      </div>

      <button @click="infoModal=!infoModal">تایید</button>
    </div>
  </div>
  <!-- modal  -->
  <!--  /modals-->
  <div class="d-flex align-items-center justify-content-center mb-4">

   <a :style="type==='producer' ? 'width: 10vw': ''"
    style="margin-top: 1.3vw;margin-left: 1vw; margin-right: 0.2vw; background-color: green; border-color: green"
    class="btn btn-primary btn-submit-1"
   ></a>
    <div v-if="!status_loading">
      <span @click="acceptComplete" v-if="type==='approver'">تایید</span>
      <span @click="acceptCompleteModal=true" v-else>ارائه جهت تایید مدیرعامل</span>
    </div>
    <div v-else>
<!--      <div class="loader-line"></div>-->
    </div>


    <a v-if="type==='approver'"
       style="margin-top: 1.3vw;margin-left: 1vw; margin-right: 0.2vw;background-color: red; border-color: red;"
       class="btn btn-primary btn-submit-1"
       @click="acceptComplete2"
    >
      <div v-if="!status_loading2">
        <span>عدم تایید</span>
      </div>
      <div v-else>
        <div class="loader-line"></div>
      </div>
    </a>
  </div>
  <div dir="rtl" class="modal__error slide-top" v-show="acceptCompleteModal" style="z-index: 999999999999999; top: 40%;">
    <div>
      <p>اخطار</p>
      <p @click="acceptCompleteModal=!acceptCompleteModal">❌</p>
    </div>
    <div>
      <p>آیا از ارائه به مدیرعامل مطمئن هستید؟</p>
      <div class="form-buttons row d-flex justify-content-around mt-5 mb-3" style="width: 20vw;">
        <button @click="acceptCompleteModal=!acceptCompleteModal" class="btn btn-primary btn-back" type="submit">برگشت</button>
        <button class="btn btn-primary btn-approve" @click="acceptComplete">تایید</button>
      </div>
    </div>
  </div>
  <div dir="rtl" class="modal__error slide-top" v-show="infoCancelled" style="z-index: 999999999999999; top: 40%;">
    <div>
      <p>عدم تایید</p>
      <p @click="infoCancelled=!infoCancelled">❌</p>
    </div>
    <div>
      <p>علت عدم تایید خود را بصورت کامل شرح دهید:</p>
      <textarea v-model="text_info" class="form-control" name="" id="" cols="30" rows="10"></textarea>
      <div class="form-buttons row d-flex justify-content-around mt-5 mb-3" style="width: 20vw;">
        <button @click="infoCancelled=!infoCancelled" class="btn btn-primary btn-back" type="submit">برگشت</button>
        <button class="btn btn-primary btn-approve" @click="acceptComplete3">تایید</button>
      </div>
    </div>
  </div>
  <div dir="rtl" class="modal__error slide-top" v-show="infoCancelledModal" style="z-index: 999999999999999; top: 40%;">
    <div>
      <p>دلایل عدم تایید</p>
      <p @click="infoCancelledModal=!infoCancelledModal">❌</p>
    </div>
    <div>
      <div class="bg-white p-3 rounded w-100 text-right">
        <p>{{textAlert}}</p>
      </div>
      <div class="form-buttons row d-flex justify-content-around mt-5 mb-3" style="width: 20vw;">
        <button @click="infoCancelledModal=false" class="btn btn-primary btn-back" type="submit">برگشت</button>
      </div>
    </div>
  </div>
  <div dir="rtl" class="modal__error slide-top" v-show="showReSubmit" style="z-index: 999999999999999; top: 40%;">
    <div>
      <p>آیا مطمئن هستید تمامی موارد مشکل دار را رفع کرده اید؟</p>
      <p @click="showReSubmit=!showReSubmit">❌</p>
    </div>
    <div>
      <div class="bg-white p-3 rounded w-100 text-right">
        <p>{{textAlert}}</p>
      </div>
      <div class="form-buttons row d-flex justify-content-around mt-5 mb-3" style="width: 20vw;">
        <button @click="showReSubmit=false" class="btn btn-primary btn-back" type="submit">برگشت</button>
        <button @click="acceptComplete4" class="btn btn-primary btn-submit-1" type="submit">تایید نهایی</button>
      </div>
    </div>
  </div>

</template>

<script>
import Splash from "@/components/Splash/Splash";
import Sidebar from "@/components/Sidebar/Sidebar";
import router from "@/router";
import {useToast} from "vue-toastification";
import Reset from "@/components/Icons/Reset.vue";
import vSelect from "vue-select";
const toast = useToast();

export default {
  name: "ListOrganization",
  components: {vSelect, Reset, Sidebar, Splash},
  data() {
    return {

      id: '',
      type:null,
      name: '',
      textAlert: '',
      status_loading2: false,
      infoCancelled: false,
      showReSubmit: false,
      addModal: false,
      Isblur: false,
      deleteModal: false,
      select_parent: false,
      select_curator: false,
      select_substitute: false,
      id_remove: '',
      editModal: false,
      infoModal: false,
      data_entry:0,
      Error: false,
      is_update: false,
      show_insert: false,
      id_tem: false,
      ErrorM: '',
      searchUser: '',
      parent_item: '',
      all_items: [],
      infoCancelledModal: false,
      seconder_ban: false,
      isWrite: false,
      approver_ban: false,
      status_show: false,
      status_approver: false,
      status_seconder_step: false,
      status_seconder: false,
      status_loading: false,
      acceptCompleteModal: false,
      not_show: true,

    }
  },
  methods: {


    acceptComplete() {
      this.acceptCompleteModal = false
      if (this.status_show) {
        return;
      }
      if (this.status_loading) {
        return;
      }
      if (!this.infoCancelled) {
        if (this.$cookies.isKey('type_1')) {
          if (this.status_show) {
            this.text_info = ''
            this.infoCancelled = true
            return;
          }
        }
      }
      if (this.seconder_ban || this.approver_ban) {
        this.showReSubmit = true
        return;
      }
      this.status_loading = true
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      if (this.text_info) {
        formdata.append('text', this.text_info)
      }
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/ExecutiveElements/update/self/u`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              toast.error(response.error)
              this.status_loading = false
              return
            }
            if (response.message) {
              toast.success(response.message)
              this.status_show = !this.status_show
              this.status_loading = false
              this.fetchAll()
            }
            this.infoCancelled = false
          })
          .catch();
    },
    setShow() {
      if (this.type==='producer') {
        if (this.status_show === false) {
          this.show_insert = true
          return;
        }
        this.show_insert = true
      }
      this.show_insert = false
    },
    acceptComplete4() {
      this.status_loading = true
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      if (this.text_info) {
        formdata.append('text', this.text_info)
      }
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/ExecutiveElements/update/self/u`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              toast.error(response.error)
              this.status_loading = false
              return
            }
            if (response.message) {
              toast.success(response.message)
              this.status_show = !this.status_show
              this.status_loading = false
              this.fetchAll()
            }
            this.infoCancelled = false
            this.showReSubmit = false
          })
          .catch();
    },
    acceptComplete2() {
      if (this.status_loading) {
        return;
      }
      if (!this.infoCancelled) {
        if (this.$cookies.isKey('type_1')) {
          if (this.status_show) {
            this.text_info = ''
            this.infoCancelled = true
            return;
          }
        }
      }
      this.infoCancelled = true
    },
    acceptComplete3(){
      this.status_loading2 = true
      if (!this.status_show){
        var myHeaders = new Headers();
        myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
        var formdata = new FormData();
        if (this.text_info){
          formdata.append('text', this.text_info)
        }
        var requestOptions = {
          method: 'POST',
          headers: myHeaders,
          body: formdata,
          redirect: 'follow'
        };
        fetch(`${this.base_url}/ExecutiveElements/update/self/u`, requestOptions)
            .then(response => response.json())
            .then(response => {


            })
            .catch();
      }
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      if (this.text_info){
        formdata.append('text', this.text_info)
      }
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/ExecutiveElements/update/self/u`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error){
              toast.error(response.error)
              this.status_loading2 = false
              return
            }
            if (response.message){
              toast.success(response.message)
              this.status_show=!this.status_show
              this.status_loading2 = false
              this.fetchAll()
            }
            this.infoCancelled = false

          })
          .catch();
    },


    // *************************************


    edit(id,name,parent){
      this.is_update = true
      this.id_tem = id
      this.name = name
      this.parent_item = parent
    },

    deleteModalMethod(id) {
      this.id = id
      this.deleteModal = true
    },
    deleteItemForm(id) {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();


      var requestOptions = {
        method: 'DELETE',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(`${this.base_url}/ExecutiveElements/${id}`, requestOptions)
          .then(response => response.json())
          .then(result => {
            if (result.error) {
              this.Error = true
              this.ErrorM = result.error
            }
            this.deleteModal = false
            this.all_items.length = 0
            toast.success(result.data)
            this.fetchAll()

          })
          .catch();
    },
    setcolor(level) {

      if (level === 0) {
        return `background: #86D1FF !important`

      }


      if (level === 1) {
        return 'background: #bce6ff !important'

      }
      if (level === 2) {
        return 'background: #d9f1ff !important'

      } else {
        return 'background: rgba(#d9f1ff, 40%) !important'
      }


    },
    submitForm() {
      setTimeout(() => {
        if (this.name.length === 0) {
          this.Error = !this.Error
          this.ErrorM = 'عنوان   اجباری است!'
          this.loading = false

          return;
        }


        fetch(`${this.base_url}/ExecutiveElements`, {
          method: 'POST',
          headers: {
            "Authorization": `Bearer ${this.$cookies.get('token')}`,
            'Content-type': 'application/json; charset=UTF-8',
          },
          body: JSON.stringify({
            'name': this.name,
            'parent_item': this.parent_item && this.parent_item.code,



          }),
        })
            .then(response => response.json())
            .then((response) => {
              if (response['error']) {
                this.Error = true
                this.ErrorM = response['error']
                this.loading = false
                return
              }
              toast.success(response.message)

              this.Isblur = false
              this.loading = false
              this.all_items.length = 0
              this.fetchAll()
              this.resetForm()


            }).catch((err) => {
        })


      }, 1000)
    },
    update(id) {
      setTimeout(() => {
        if (this.name.length === 0) {
          this.Error = !this.Error
          this.ErrorM = 'عنوان   اجباری است!'
          this.loading = false

          return;
        }


        fetch(`${this.base_url}/ExecutiveElements/update/${id}`, {
          method: 'POST',
          headers: {
            "Authorization": `Bearer ${this.$cookies.get('token')}`,
            'Content-type': 'application/json; charset=UTF-8',
          },
          body: JSON.stringify({
            'name': this.name,
            'parent_item': this.parent_item && this.parent_item.code,



          }),
        })
            .then(response => response.json())
            .then((response) => {
              if (response['error']) {
                this.Error = true
                this.ErrorM = response['error']
                this.loading = false
                return
              }
              this.is_update = false
              this.all_items.length = 0
              this.fetchAll()
              this.resetForm()


            }).catch((err) => {
        })


      }, 1000)
    },
    resetForm() {
      this.name = ''
      this.is_update=false
      this.id=''
      this.id_tem=''
      this.parent_item = ''

    },

    fetchAll(){
      fetch(`${this.base_url}/ExecutiveElements`, {
        method: 'GET',
        headers: {
          "Authorization": `Bearer ${this.$cookies.get('token')}`,
          'Content-type': 'application/json; charset=UTF-8',
        },

      })
          .then(response => response.json())
          .then((response) => {
            if (response['error']) {

              return
            }
            if (response.all){
              this.all_items = [...response.all]
              this.data_entry=response.data_entry
              this.type=response.type
            }

        

            if (!response.status_seconder) {
              if (response.status) {
                this.status_seconder = true
                this.show_insert = false
                this.$store.commit('setExecutiveElement', false)

              }if (response.status===0){
                this.show_insert = true
                this.$store.commit('setExecutiveElement', true)

              }
            }
            if (!this.status_approver && this.$cookies.isKey('type_1')) {
              this.status_seconder = false
            }
            if (response.status && !response.status_approver) {
              this.status_seconder = true
            }
            if (response.seconder_ban) {
              this.seconder_ban = true
              this.show_insert = true
              this.$store.commit('setExecutiveElement', true)

              this.textAlert = response.message ?? 'موردی یافت نشد'
            }
            if (response.approver_ban) {
              this.approver_ban = true
              this.show_insert = true
              this.$store.commit('setExecutiveElement', true)

              this.textAlert = response.message ?? 'موردی یافت نشد'
            }

            if (response.status_approver) {
              this.status_approver = true
            }
            if (response.text_seconder) {
              this.seconder_ban = true
              this.textAlert = response.text_seconder ?? 'موردی یافت نشد'
            }
            if (parseInt(response.step) === 1) {
              this.status_seconder_step = true
              this.status_seconder = true
              this.$store.commit('setExecutiveElement', false)

            }
            if (parseInt(response.step) === 2) {
              this.status_seconder_step = true
              this.status_seconder = false
            }
            if (parseInt(response.step) === 0) {
              this.status_seconder_step = false

            }
            this.isWrite = response.isWrite
            if ((parseInt(response.step)===1&&this.type_two)||(parseInt(response.step)===2&&this.type_two) || (parseInt(response.step)===2&&this.type_one) || parseInt(response.step)===3){
              this.not_show = false
            }

          }).catch((err) => {
      })
    },

    checkIsMother(){
      if (this.is_mother){
        router.push('/mother_items')
        return
      }

    }
  },
  mounted() {
    this.checkIsMother()
    this.fetchAll()
  },
  computed: {
    filteredItems() {
      return this.all_items.filter(item => {
        return (
            item['name']&& item['name'].includes(this.searchUser)
        );
      });
    },


  },
}
</script>

<style scoped>
label {
  width: 100%;
  text-align: right;
}

table {
  background-color: white !important;
}


img {
  cursor: pointer;
}

tr {
  background-color: #ffff !important;
}
.changer{
  background-color: #AFAFAF;
  height: 2vw;
  border-radius: 1vw;
  width: 10vw;
  margin-bottom: 2vw;
  justify-content: space-evenly;
  &>p:nth-child(1){
    width: 11vw;
    height: 2vw;
    background-color: #3742FA;
    color: #fff;
    transform: translateX(.9vw);
    border-radius: 1vw;
  }
  &>p:nth-child(2){
    margin-left: 1vw;
  }  &>p {
       cursor: pointer;
       font-size: 1vw;
     }
  &>a{
    color: black;
    text-decoration: none;
    margin-left: .9vw;
  }
}
</style>